// Vite + Vue 3 entrypoint
// Use vite_typescript_tag 'application' in layouts to load this
import { createApp } from 'vue'
import ProjectTimeline from '../components/ProjectTimeline.vue'
import ProjectGantt from '../components/ProjectGantt.vue'
import KanbanBoard from '../components/KanbanBoard.vue'
import ProjectSchedule from '../components/ProjectSchedule.vue'

const components: Record<string, any> = {
  'project-timeline': ProjectTimeline,
  'project-gantt': ProjectGantt,
  'kanban-board': KanbanBoard,
  'project-schedule': ProjectSchedule
}

// Mount Vue apps on elements with data-vue-app attribute
document.addEventListener('DOMContentLoaded', () => {
  const containers = document.querySelectorAll<HTMLElement>('[data-vue-app]')
  containers.forEach((el) => {
    const appName = el.dataset.vueApp
    if (appName && components[appName]) {
      const app = createApp(components[appName], dataProps(el))
      app.mount(el)
    }
  })
})

function dataProps(el: HTMLElement): Record<string, string> {
  const props: Record<string, string> = {}
  const url =
    el.dataset.timelineUrl ||
    el.dataset.ganttUrl ||
    el.dataset.kanbanUrl ||
    el.dataset.scheduleUrl
  if (url) props.url = url
  if (el.dataset.moveUrl) props.moveUrl = el.dataset.moveUrl
  return props
}
